import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";

const ProfileHeader = ({ user }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            bgcolor: '#E8EFFF',
            mr: 1,
            '&:hover': { bgcolor: '#D0DFFF' },
            width: 32,
            height: 32,
            borderRadius: '8px'
          }}
          size="small"
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 14, color: '#0E2465' }} />
        </IconButton>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#0E2465' }}>
          Atrás
        </Typography>
      </Box>

      <Box className="profile-header-banner">
        <Box className="banner-content">
          <Typography variant="h3" component="h1" sx={{ color: 'white', fontWeight: 700, mb: 1 }}>
            Perfil <br /> del proveedor
          </Typography>
          <Typography variant="body1" color="primary">
            Conoce el perfil de {user?.name || 'el proveedor'}, su experiencia y los servicios que ofrece
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileHeader;
